import Agreement from './agreement';
import Base from './base/ContractInputBase';
import DistributionSection from './distributionSection/ContractInputDistributionSection';
import Main from './main/ContractInputMain';
import ParagraphSection from './paragraphSection/ContractInputParagraphSection';
import Section from './section/ContractInputSection';
import Wrapper from './wrapper/ContractInputWrapper';

export default {
  Base,
  Wrapper,
  Section,
  ParagraphSection,
  Main,
  Agreement,
  DistributionSection,
};
